import React from 'react';
import { Text, StyledTable } from 'components';
import { isMedia, formatDate } from 'helpers';

export default class CurrentShowsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: false,
      columnExpander: '',
      selected: ''
    };
  }

  componentDidMount() {}

  render() {
    const { bookings } = this.props;
    const paginateCancelledBookings =
      bookings.filter(booking => {
        return booking.state === 'cancelled';
      }).length > 3
        ? true
        : false;

    return (
      <div>
        <br />
        <Text large bold>
          Cancelled Shows
        </Text>
        <br />
        <br />
        <StyledTable
          data={bookings
            .filter(booking => {
              return booking.state === 'cancelled';
            })
            .sort((a, b) =>
              b.cancelled_at > a.cancelled_at
                ? 1
                : a.cancelled_at > b.cancelled_at
                ? -1
                : 0
            )}
          noDataText="No current shows."
          noShadow
          columns={[
            {
              Header: 'Title',
              accessor: 'show.name',
              minWidth: 125
            },
            {
              Header: 'Cancellation',
              accessor: 'cancelled_at',
              minWidth: 100,
              Cell: row => <div>{formatDate(row.value, 'YYYY-MM-DD')}</div>
            },
            {
              Header: 'Opening',
              accessor: 'opening',
              minWidth: 90,
              show: isMedia() !== 'phone'
            },
            {
              Header: 'Closing',
              accessor: 'expiration',
              minWidth: 90,
              show: isMedia() !== 'phone'
            }
          ]}
          resizable={false}
          sortable={false}
          showPagination={paginateCancelledBookings}
          showPaginationTop={false}
          showPaginationBottom={true}
          showPageSizeOptions={false}
          minRows={1}
          defaultPageSize={10}
        />
      </div>
    );
  }
}
